import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import "./Cgu.css";
import Header from '../header/header';
import Footer from '../commun/Footer';

const FaqCooptaleo = () => (
                <>

    < Header />
  <Container maxWidth="md" className="cgu-container">
    <Box py={5}>
      <Typography variant="h4" align="center" gutterBottom>
        FAQ – Questions fréquentes
      </Typography>

      <Divider className="cgu-divider" />

      {/* 1. Questions générales */}
      <Typography variant="h6" gutterBottom>
        1. Questions générales
      </Typography>
      <Typography className="faq-q" gutterBottom>
        Qu’est-ce que Cooptaleo ?
      </Typography>
      <Typography paragraph>
        Cooptaleo est une plateforme de mise en relation entre entreprises, recruteurs indépendants et experts IT, facilitée par une technologie de matching basée sur l’intelligence artificielle.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Comment fonctionne le matching avec l’IA ?
      </Typography>
      <Typography paragraph>
        L’IA analyse les besoins des entreprises et les profils des talents pour recommander automatiquement les meilleures correspondances, en tenant compte des compétences, des préférences et du contexte de mission.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Est-ce que l’inscription est gratuite ?
      </Typography>
      <Typography paragraph>
        Oui, l’inscription est entièrement gratuite pour les entreprises, les recruteurs et les talents. Certaines fonctionnalités avancées peuvent être soumises à conditions ou abonnement.
      </Typography>

      {/* 2. Côté entreprise */}
      <Typography variant="h6" gutterBottom>
        2. Côté entreprise
      </Typography>
      <Typography className="faq-q" gutterBottom>
        Comment déposer une mission ?
      </Typography>
      <Typography paragraph>
        Créez un compte entreprise, remplissez le formulaire de mission en quelques clics, et publiez votre besoin. Des recruteurs indépendants qualifiés pourront se positionner et vous proposer des profils adaptés.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Puis-je suivre les candidats proposés ?
      </Typography>
      <Typography paragraph>
        Oui, vous avez un espace dédié pour suivre chaque candidature, dialoguer avec les recruteurs, et prendre une décision en toute transparence.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Quelles garanties en cas de litige ?
      </Typography>
      <Typography paragraph>
        Une interface support est disponible en cas de désaccord. Les interactions sont tracées et un historique complet est conservé pour assurer la transparence.
      </Typography>

      {/* 3. Côté recruteur et candidat */}
      <Typography variant="h6" gutterBottom>
        3. Côté recruteur et candidat
      </Typography>
      <Typography className="faq-q" gutterBottom>
        Je suis recruteur indépendant, comment proposer un profil ?
      </Typography>
      <Typography paragraph>
        Après validation de votre compte, vous pouvez consulter les missions ouvertes et proposer vos profils en quelques clics via l’interface dédiée.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Comment sont calculées les primes ?
      </Typography>
      <Typography paragraph>
        Vous touchez une prime sur chaque mission pour laquelle un talent que vous avez proposé est recruté. Le montant et les conditions sont affichés clairement dans l’espace mission.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Je suis candidat, dois-je postuler moi-même ?
      </Typography>
      <Typography paragraph>
        Non. Une fois votre CV déposé, ce sont les recruteurs qui vous contacteront lorsqu’un besoin correspond à votre profil. Vous restez libre d’accepter ou non.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Mes données sont-elles protégées ?
      </Typography>
      <Typography paragraph>
        Oui. Vos données sont stockées en Europe (hébergement OVH), conformes au RGPD. Vous pouvez à tout moment modifier ou supprimer votre compte.
      </Typography>

      {/* 4. Questions sur la sécurité et la confidentialité */}
      <Typography variant="h6" gutterBottom>
        4. Questions sur la sécurité et la confidentialité
      </Typography>
      <Typography className="faq-q" gutterBottom>
        Qui peut voir mes informations personnelles ?
      </Typography>
      <Typography paragraph>
        Seuls les recruteurs ou entreprises autorisés et engagés dans une mission peuvent accéder à votre profil complet. Vos données ne sont jamais revendues ou exposées publiquement.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Puis-je anonymiser mon CV ?
      </Typography>
      <Typography paragraph>
        Oui. Vous pouvez choisir de masquer vos coordonnées personnelles, ou utiliser notre fonctionnalité de génération de CV anonymisé.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Que faire en cas de suspicion de fraude ou de comportement abusif ?
      </Typography>
      <Typography paragraph>
        Un bouton de signalement est disponible dans votre espace. Chaque cas est traité rapidement par notre équipe support.
      </Typography>

      {/* 5. Délais, paiements et primes */}
      <Typography variant="h6" gutterBottom>
        5. Délais, paiements et primes
      </Typography>
      <Typography className="faq-q" gutterBottom>
        Combien de temps faut-il pour recevoir des profils ?
      </Typography>
      <Typography paragraph>
        Une fois la mission publiée, les premiers positionnements de recruteurs arrivent généralement sous 24 à 72h.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Quand les recruteurs sont-ils payés ?
      </Typography>
      <Typography paragraph>
        Les primes sont versées une fois que l’entreprise confirme l’embauche effective du talent, selon les conditions affichées.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Est-ce que les missions sont exclusives ?
      </Typography>
      <Typography paragraph>
        Certaines oui, d'autres non. L’entreprise choisit de les rendre visibles à tous ou à un groupe restreint de recruteurs qualifiés.
      </Typography>

      {/* 6. Aspects contractuels et fonctionnement */}
      <Typography variant="h6" gutterBottom>
        6. Aspects contractuels et fonctionnement
      </Typography>
      <Typography className="faq-q" gutterBottom>
        Qui signe le contrat de prestation ?
      </Typography>
      <Typography paragraph>
        Le contrat est signé directement entre l’entreprise et le talent. Cooptaleo facilite le lien, mais ne signe pas à leur place.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Êtes-vous une ESN ou un cabinet de recrutement ?
      </Typography>
      <Typography paragraph>
        Non. Cooptaleo est une plateforme technologique de mise en relation, neutre et collaborative.
      </Typography>

      <Typography className="faq-q" gutterBottom>
        Puis-je me désinscrire à tout moment ?
      </Typography>
      <Typography paragraph>
        Oui. Vous pouvez clôturer votre compte à tout moment depuis votre espace personnel, ou en contactant notre support.
      </Typography>
    </Box>
  </Container>
  <Footer />

  </>
);

export default FaqCooptaleo;
